/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { css } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';
import DDSContentBlockCopy from '../content-block/content-block-copy';
import { COLOR_SCHEME } from '../../component-mixins/callout/defs';
import styles from './callout-with-media.scss';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The copy content of callout with media.
 *
 * @element c4d-callout-with-media-copy
 */
@customElement(`${c4dPrefix}-callout-with-media-copy`)
class C4DCalloutWithMediaCopy extends DDSContentBlockCopy {
  /**
   * The color-scheme type.
   */
  @property({ reflect: true, attribute: 'color-scheme' })
  colorScheme = COLOR_SCHEME.REGULAR;

  static get stableSelector() {
    return `${c4dPrefix}--callout-with-media-copy`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static get styles() {
    return css`
      ${super.styles}${styles}
    `;
  }
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DCalloutWithMediaCopy;
